import _remove from 'lodash/remove';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';

/**
 * @desc  ClassRoomService class.
 * @ngInject
 */
export default class ClassRoomService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   * @param {$localStorage} $localStorage
   */
  constructor(
    $rootScope, $q, $log, $http, $localStorage
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.$localStorage = $localStorage;

    this.classRooms = [];
    this.unassignedClassRooms = [];
    this.currentClassRoom = {};
    this.getClassRoomsPendingPromise = null;

    this.$rootScope.$on('SCR.change', () => {
      this.currentClassRoom = {};
    });

    this.$rootScope.$on('scr.select', () => {
      this.classRooms.splice(0, this.classRooms.length);
      this.unassignedClassRooms.splice(0, this.unassignedClassRooms.length);
    });
  }

  getClassRooms(fromServer = false, schoolCommonRoomId = 0) {
    if (this.getClassRoomsPendingPromise) {
      return this.getClassRoomsPendingPromise;
    }

    if (this.classRooms.length > 0 && !fromServer) {
      return this.$q.resolve(this.classRooms);
    }

    let scrId = this.$rootScope.me.schoolCommonRoomId;
    if (schoolCommonRoomId > 0) {
      scrId = schoolCommonRoomId;
    }

    this.getClassRoomsPendingPromise = this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${scrId}/classRoom`
    })
      .then(result => {
        this.classRooms = result.data.classRooms;
        return this.classRooms;
      }, err => this.$q.reject(err))
      .then(classRooms => {
        this.getClassRoomsPendingPromise = null;
        return classRooms;
      });

    return this.getClassRoomsPendingPromise;
  }

  getClassRoomName(id = 0) {
    if (this.classRooms.length === 0) {
      return '';
    }

    const filtered = this.classRooms.filter(item => item.id === id);
    if (filtered.length > 0) {
      return filtered[0].name;
    }

    return '';
  }

  getUnassignedClassRooms(fromServer = false) {
    if (this.unassignedClassRooms.length > 0 && !fromServer) {
      return this.$q.resolve(this.unassignedClassRooms);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/unassignedClassRoom`
    }).then(result => {
      this.unassignedClassRooms = result.data.unassignedClassRooms;
      return this.unassignedClassRooms;
    }, err => this.$q.reject(err));
  }

  assignClassRoom(classRoom) {
    const copyClassRoom = {};
    angular.copy(classRoom, copyClassRoom);
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/classRoom`,
      data: {classRoom}
    }).then(result => {
      copyClassRoom.id = result.data.id;
      _remove(this.unassignedClassRooms, item => item.schoolClassRoomId === copyClassRoom.schoolClassRoomId);
      this.classRooms.push(copyClassRoom);
      this.$rootScope.$broadcast('add.classRoom');
    }, err => this.$q.reject(err));
  }

  deleteClassRoom(id) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/classRoom/${id}`
    }).then(() => {
      const classRoom = _find(this.classRooms, classRoom => classRoom.id === id);
      _remove(this.classRooms, item => item.id === id);
      this.unassignedClassRooms.push(classRoom);
    }, err => this.$q.reject(err));
  }

  setCurrentClassRoom(classRoom) {
    this.currentClassRoom = classRoom;
    this.$rootScope.currentClassRoom = this.currentClassRoom;
    this.$localStorage.currentClassRoom = this.currentClassRoom;
  }

  getCurrentClassRoom() {
    if (!_isEmpty(this.currentClassRoom)) {
      return this.$q.resolve(this.currentClassRoom);
    }

    if (!_isEmpty(this.$rootScope.currentClassRoom)) {
      return this.$q.resolve(this.$rootScope.currentClassRoom);
    }

    if (angular.isDefined(this.$localStorage.currentClassRoom)) {
      return this.$q.resolve(this.$localStorage.currentClassRoom);
    }

    if (angular.isDefined(this.$rootScope.me.schoolCommonRoomId)) {
      return this.getClassRooms().then(result => {
        const classRoom = result[0];
        return classRoom;
      })
        .catch(() => {});
    }

    return {};
  }
}
